import { makeAutoObservable } from "mobx";
import { createRef, RefObject } from "react";
import { ContextKey, ContextKeys } from "../../../types/context-key";
import { YearlyInvestmentSummary } from "../../../types/investment-summary";

export default class Context {
  private _principal: number;
  private _annualInterestRate: number;
  private _monthlyDeposit: number;
  private _numberOfYears: number;
  private _managementFeesEnabled: boolean;
  private _depositFeesPercentage: number;
  private _accumulationFeesPercentage: number;
  private _investmentSummary: YearlyInvestmentSummary[];
  private _totalDepositFees: number;
  private _totalAccumulationFees: number;
  private _investmentSummaryDisplayRef: RefObject<HTMLDivElement>;

  constructor() {
    this._principal = 0;
    this._annualInterestRate = 0;
    this._monthlyDeposit = 0;
    this._numberOfYears = 0;
    this._managementFeesEnabled = false;
    this._depositFeesPercentage = 0;
    this._accumulationFeesPercentage = 0;
    this._investmentSummary = [];
    this._totalDepositFees = 0;
    this._totalAccumulationFees = 0;
    this._investmentSummaryDisplayRef = createRef<HTMLDivElement>();
    makeAutoObservable(this);
  }

  get principal(): number {
    return this._principal;
  }

  get annualInterestRate(): number {
    return this._annualInterestRate;
  }

  get monthlyDeposit(): number {
    return this._monthlyDeposit;
  }

  get numberOfYears(): number {
    return this._numberOfYears;
  }

  get managementFeesEnabled(): boolean {
    return this._managementFeesEnabled;
  }

  get depositFeesPercentage(): number {
    return this._depositFeesPercentage;
  }

  get accumulationFeesPercentage(): number {
    return this._accumulationFeesPercentage;
  }

  get investmentSummary(): YearlyInvestmentSummary[] {
    return this._investmentSummary;
  }

  get totalDepositFees(): number {
    return this._totalDepositFees;
  }

  get totalAccumulationFees(): number {
    return this._totalAccumulationFees;
  }

  set investmentSummary(value: YearlyInvestmentSummary[]) {
    this._investmentSummary = value;
  }

  set totalDepositFees(value: number) {
    this._totalDepositFees = value;
  }

  set totalAccumulationFees(value: number) {
    this._totalAccumulationFees = value;
  }

  set investmentSummaryDisplayRef(value: RefObject<HTMLDivElement>) {
    this._investmentSummaryDisplayRef = value;
  }

  get investmentSummaryDisplayRef(): RefObject<HTMLDivElement> {
    return this._investmentSummaryDisplayRef;
  }

  updateKey(key: ContextKey, value: number | boolean) {
    switch (key) {
      case ContextKeys.PRINCIPAL:
        this._principal = value as number;
        break;
      case ContextKeys.ANNUAL_INTREST_RATE:
        this._annualInterestRate = value as number;
        break;
      case ContextKeys.MONTHLY_DEPOSIT:
        this._monthlyDeposit = value as number;
        break;
      case ContextKeys.NUMBER_OF_YEARS:
        this._numberOfYears = value as number;
        break;
      case ContextKeys.MANAGEMENT_FEES_ENABLED:
        this._managementFeesEnabled = value as boolean;
        break;
      case ContextKeys.DEPOSIT_FEES_PERCENTAGE:
        this._depositFeesPercentage = value as number;
        break;
      case ContextKeys.ACCUMULATION_FEES_PERCENTAGE:
        this._accumulationFeesPercentage = value as number;
        break;
      default:
        break;
    }
  }
}
